"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCryptocurrency01 = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M8.055 3.91a1 1 0 0 0-.877-1.797 11 11 0 0 0-6.07 11.418 1 1 0 0 0 1.98-.279 9 9 0 0 1 4.967-9.341ZM15.485 2.574a1 1 0 0 1 1.337-.46 11 11 0 0 1 6.07 11.417 1 1 0 1 1-1.98-.279 9 9 0 0 0-4.967-9.341 1 1 0 0 1-.46-1.337ZM5.313 19.503a1 1 0 0 1 1.397-.222 9 9 0 0 0 10.58 0 1 1 0 1 1 1.176 1.618 11 11 0 0 1-12.932 0 1 1 0 0 1-.22-1.396Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 5.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z", fill: "currentColor" })] }))); };
exports.default = SvgCryptocurrency01;
